const inputStyles = {
    control: (baseStyles, state) => ({
        border: "solid 1px #9DD6F7",
        background: "#FAFDFF",
        outline: state.isFocused ? "solid 2px black" : "none",
        outlineOffset: "-1px",
        display: "flex",
        alignItems: "center",
        width: "100%",
        padding: "5px 15px 5px 15px",
        height: "40px",
        fontSize: "16px",
        borderRadius: "15px",
        color: "black",
        fontFamily: "ccmiInterMedium"
    }),
    indicatorSeparator: () => ({
        display: "none",
    }),
    dropdownIndicator: (baseStyles) => ({
        fill: "black"
    }),
    valueContainer: (baseStyles) => ({
        ...baseStyles,
        padding: "none",
    }),
    input: (baseStyles) => ({
        ...baseStyles,
        color: "black",
        fontFamily: "ccmiInterMedium"
    }),
    singleValue: (baseStyles) => ({
        ...baseStyles,
        color: "black",
    }),
    option: (baseStyles, state) => ({
        ...baseStyles,
        color: "black",
        background: state.isFocused ? "#9DD6F7" : "#FAFDFF"
    })
}


export default {
    inputStyles,
}